import { createChannelManagementInstance } from '../api-instance';
import type { TRequestOptions } from '../types';

export interface MaxPersonalConnectResponse {
  channelId: string;
  qrBase64?: string;
  status: 'qr_in_progress' | 'authorized' | 'password_required';
  expiresAt: string;
}

export interface MaxPersonalQrResponse {
  qrBase64?: string;
  expiresAt: string;
}

export const connectMaxPersonal = (
  channelId: string,
  name?: string,
  options?: TRequestOptions
): Promise<MaxPersonalConnectResponse> =>
  createChannelManagementInstance<MaxPersonalConnectResponse>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/max-personal/connect`,
      method: 'POST',
      data: name !== undefined ? { name } : {},
    },
    options
  );

export const refreshMaxPersonalQr = (
  channelId: string,
  options?: TRequestOptions
): Promise<MaxPersonalQrResponse> =>
  createChannelManagementInstance<MaxPersonalQrResponse>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/max-personal/qr`,
      method: 'GET',
    },
    options
  );

export const submitMaxPersonal2fa = (
  channelId: string,
  password: string,
  options?: TRequestOptions
): Promise<void> =>
  createChannelManagementInstance<void>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/max-personal/2fa`,
      method: 'POST',
      data: { password },
    },
    options
  );

export const disconnectMaxPersonal = (
  channelId: string,
  options?: TRequestOptions
): Promise<void> =>
  createChannelManagementInstance<void>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/max-personal/disconnect`,
      method: 'POST',
      data: {},
    },
    options
  );
